import {
  SELECT_RELATION,
  DESELECT_RELATION,
  SELECT_ORDER,
  DESELECT_ORDER,
  SELECT_SHIPMENT,
  DESELECT_SHIPMENT,
  SELECT_CARRIER,
  DESELECT_CARRIER,
  SELECT_CONTACT,
  DESELECT_CONTACT,
  DESELECT_ALL
} from "../actions/select_actions";

const selectReducer = (
  state = {
    carrier: {},
    relation: {},
    order: {},
    shipment: {},
    contact: {}
  },
  action
) => {
  switch (action.type) {
    case SELECT_RELATION:
      return { ...state, relation: action.payload };
    case DESELECT_RELATION:
      return { ...state, relation: {} };
    case SELECT_ORDER:
      return { ...state, order: action.payload };
    case DESELECT_ORDER:
      return { ...state, order: {} };
    case SELECT_SHIPMENT:
      return { ...state, shipment: action.payload };
    case DESELECT_SHIPMENT:
      return { ...state, shipment: {} };
    case SELECT_CARRIER:
      return { ...state, carrier: action.payload };
    case DESELECT_CARRIER:
      return { ...state, carrier: {} };
    case SELECT_CONTACT:
      return { ...state, contact: action.payload };
    case DESELECT_CONTACT:
      return { ...state, contact: {} };
    case DESELECT_ALL:
      return {
        ...state,
        carrier: {},
        relation: {},
        order: {},
        shipment: {},
        contact: {}
      };
    default:
      return state;
  }
};

export default selectReducer;



// WEBPACK FOOTER //
// ./src/reducers/select_reducer.js